import { combineReducers } from 'redux'
import PageShellReducer from '../../components/header/header-reducer'
import sessionReducer from "./sessionReducer";
import cookieReducer from "./cookieReducer";

const rootReducer = combineReducers({
  pageShell: PageShellReducer,
  session: sessionReducer,
  cookie: cookieReducer
})

export default rootReducer
